/**
 * Рендер иконки удобства по данным из БД (правки Артёма 2026-06-17).
 *
 * Иконки больше не inline-реестр на фронте, а пак в platform.icons
 * (GET /v1/icons). Каждая запись хранит svg — внутреннюю разметку
 * (<path>/<circle>/<rect>); общие атрибуты (viewBox/stroke=currentColor/
 * strokeWidth/linecap) проставляет ЭТОТ компонент, как делал NavIcon.
 * Цвет наследуется (currentColor).
 *
 * svg приходит из НАШЕГО же сида/каталога (не пользовательский ввод) —
 * это контуры Phosphor-стиля. Рендерим через dangerouslySetInnerHTML
 * внутрь <svg>-обёртки с фиксированными безопасными атрибутами.
 */
import type { IconView } from '@hsc/types';

export interface DbIconProps {
  /** Иконка из каталога (GET /v1/icons). Undefined → нейтральный кружок. */
  icon?: IconView | undefined;
  /** Размер в px (квадрат). По умолчанию 18. */
  size?: number;
  className?: string;
}

const FALLBACK_SVG = '<circle cx="12" cy="12" r="9" />';

/** Рендерит inline-SVG иконку из БД с безопасной обёрткой. */
export function DbIcon({ icon, size = 18, className }: DbIconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size}
      height={size}
      aria-hidden
      focusable={false}
      {...(className ? { className } : {})}
      data-icon-key={icon?.key ?? 'unknown'}
      dangerouslySetInnerHTML={{ __html: icon?.svg ?? FALLBACK_SVG }}
    />
  );
}
